module.exports = __webpack_public_path__ + "img/SUD_logo.64962b21.jpg";